import React, { Component } from 'react'
import { withTheme } from 'styled-components';

import { Flex, FlexColumn } from '../../../../Reusable/Container';
import { Tag, Text } from '../../../../Reusable/Text';
import hexToRgba from 'hex-to-rgba';
import BillTable from '../../../Bills/BillTable';
import { getLogoFromDomain, toCurrency, toAbsCurrency, dateFormatList } from '../../../../../Utils/util';
import { apiPOSTReq } from '../../../../../Utils/api';
import environment from '../../../../../environment';
import { InitialCircle } from '../../../../Reusable/InitialCircle';

import { CardContainer } from './CardContainer';
import VendorCard from './VendorCard';
import { LabeledInput } from '../../../../Reusable/Input';
import moment from 'moment';
import ExpenseCategorizationSummary from './ExpenseCategorizationSummary';
import AI from '../../../../../Images/AI.svg';
import { Image } from '../../../../Reusable/Image';
import { Button } from '../../../../Reusable/Button';

class EditBill extends Component {
    state = {
        bill: this.props.bill,
        vendor: this.props.vendor
    }

    componentDidMount() {
    }

    saveInput = (id, dataToSave) => {
        var { bill } = this.state;

        bill[id] = dataToSave;
        this.setState({ bill });
    }

    render() {
        var { theme, inboxItem } = this.props;
        var { bill, vendor, errorField, loading } = this.state;
        bill = bill || {};
        vendor = vendor || {};

        var { amount, dueDate, invoiceNumber, billDate } = bill;
        const dateFormat = environment.defaultDateFormat;

        return (
            <FlexColumn gap='24px' style={{ marginTop: '24px', marginBottom: '48px' }}>

                <CardContainer padding='12px 12px'>
                    <Flex start centerHorizontally gap='16px'>
                        <Image src={AI} />
                        <Text>Our AI Engine automatically captured important details from your bill. Feel free to modify as needed.</Text>
                    </Flex>
                </CardContainer>

                <CardContainer gap='16px'>
                    <Text size='16px' weight={600}>Vendor details</Text>
                    <VendorCard 
                        editMode
                        vendor={vendor} 
                        onEdit={() => this.props.loadStep("ChangeVendor")}
                    />
                </CardContainer>

                {/* Bill Details */}
                <CardContainer gap='16px'>
                    <Text size='16px' weight={600}>Bill details</Text>
                    <FlexColumn gap='24px'>
                        <Flex start gap='24px'>
                            <LabeledInput
                                label="Bill Amount"
                                type="amount"
                                nomargin
                                id="amount"
                                value={amount}
                                onChange={(value) => this.saveInput("amount", value)}
                                error={errorField === "amount"}
                                errorMessage={"This is a mandatory field"}
                                // width='250px'
                            />
                            <LabeledInput
                                label="Due Date"
                                nomargin
                                type="date-picker"
                                id="dueDate"
                                format={dateFormatList}
                                value={dueDate && moment(dueDate)}
                                placeholder={moment().add(1, "day").format(dateFormat)}
                                onChange={(date, dateStr) => this.saveInput("dueDate", moment.utc(dateStr).utcOffset(0))}
                                error={errorField === "dueDate"}
                                errorMessage={"This is a mandatory field"}
                                // width='250px'
                            />
                        </Flex>

                        <Flex start gap='24px'>
                            <LabeledInput
                                label="Bill Number"
                                nomargin
                                id="invoiceNumber"
                                style={{ fontSize: '14px' }}
                                placeholder="e.g. 194710"
                                value={invoiceNumber}
                                onChange={(e) => this.saveInput(e.target.id, e.target.value)}
                                error={errorField === "billNumber"}
                                errorMessage={"This is a mandatory field"}
                                // width='250px'
                            />
                            <LabeledInput
                                label="Bill Date"
                                nomargin
                                type={"date-picker"}
                                id="billDate"
                                format={dateFormatList}
                                value={billDate && moment(billDate)}
                                placeholder={moment().add(0, "day").format(dateFormat)}
                                onChange={(date, dateStr) => {
                                    this.saveInput("billDate", moment.utc(dateStr).utcOffset(0))
                                }}
                                onKeyDown={this.handleOnKeyDown}
                                error={errorField === "billDate"}
                                errorMessage={"This is a mandatory field"}
                                // width='250px'
                            />
                        </Flex>
                    </FlexColumn>
                </CardContainer>

                {/* Expense categorization */}
                <CardContainer>
                    <ExpenseCategorizationSummary 
                        editMode 
                        bill={bill}
                        onEdit={() => this.props.loadStep("EditExpenseCategorization")}
                    />
                </CardContainer>

                <FlexColumn left>
                    <Button
                        solid 
                        onClick={() =>  {
                            if(inboxItem) {
                                this.props.updateBillVendor({ bill });
                                this.props.loadStep("Summary");
                            } else {
                                this.setState({ loading: true });
                                this.props.saveBill(bill, () => {
                                    this.setState({ loading: false });
                                    this.props.updateBillVendor({ bill });
                                    this.props.loadStep("Summary");
                                });
                            }
                        }}
                        loading={loading}
                        text={inboxItem ? "DONE" : "SAVE"} 
                    />
                </FlexColumn>
            </FlexColumn>
            
        )
    }
}

export default withTheme(EditBill)